import { ContentCopy, Share } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grow from '@mui/material/Grow';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';
import { PromoTileData } from '../../../types';

export function PromoItem(props: { promo: PromoTileData }) {
  // Props
  const { promo } = props;
  // State
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [showShare, setShowShare] = React.useState<boolean>(false);

  const handleShare = async (promo: PromoTileData) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: promo.Title,
          text: 'This is an awesome link that I wanted to share with you.',
          url: promo.ActionLink || promo.ImageURL,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // Fallback: Copy to clipboard
      navigator.clipboard.writeText(promo.ImageURL).then(() => {
        setSnackbarMessage('Link copied to clipboard!');
        setOpenSnackbar(true);
      });
    }
  };

  return (
    <Box
      sx={{
        position: 'relative',
        p: 1,
        '&:hover': {
          cursor: promo.ActionLink ? 'pointer' : 'default',
        },
      }}
      onMouseEnter={() => setShowShare(true)}
      onMouseLeave={() => setShowShare(false)}
    >
      <Box
        component={promo.ActionLink ? 'a' : 'div'}
        {...(promo.ActionLink && {
          href: promo.ActionLink,
          target: '_blank',
          rel: 'noopener noreferrer',
        })}
      >
        <Box
          component="img"
          src={promo.ImageURL}
          sx={{
            borderRadius: 3,
            width: '100%',
            transition: 'all 0.2s',
            transform: showShare ? 'scale(1.03)' : 'none',
            // boxShadow: '0px 2px 5px black',
          }}
        />
        <Grow in={showShare}>
          <Button
            size="small"
            sx={{
              position: 'absolute',
              bottom: 20,
              right: 20,
              fontWeight: 700,
              letterSpacing: 1.1,
              whiteSpace: 'nowrap',
              fontSize: 10,
              minWidth: 0,
              borderRadius: 1,
              fontFamily: 'Lato',
              // boxShadow: `0px 0px 5px 1px ${grey[900]}33`,
              border: '1px solid',
              borderColor: '#fafafa',
              background: `linear-gradient(135deg, #d3d6d9 0%, #9fa6ac 100%)`,
            }}
            onClick={() => handleShare(promo)}
          >
            Share
            <Share fontSize="small" sx={{ transform: 'scale(0.7)' }} />
          </Button>
        </Grow>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackbar(false)}
          message={snackbarMessage}
          action={
            <IconButton
              size="small"
              color="inherit"
              onClick={() => setOpenSnackbar(false)}
            >
              <ContentCopy fontSize="small" />
            </IconButton>
          }
        />
      </Box>
    </Box>
  );
}
